import React from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Card,
  CardContent,
  Grid,
  TableCell,
  TableBody,
  Table,
  TableRow
} from "@material-ui/core";
import _ from 'lodash';
import FundNotes from 'components/Global/OptionsMenu/FundTable/FundNotes';
import AddAlertIcon from "@material-ui/icons/AddAlert";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import DescriptionIcon from "@material-ui/icons/Description";
import Styles from "./styles";

const Tile = class extends React.Component {
  state = {
    hover: 0,
    isNotesOpen: false
  };

  hoverActions = () => {
    this.setState({ hover: 2 });
  };

  hoverOutActions = () => {
    this.setState({ hover: 0 });
  };

  openNotes = () => {
    this.setState({ isNotesOpen: true });
  };

  closeNotes = () => {
    this.setState({ isNotesOpen: false });
  };

  render() {
    const { fund } = this.props;    
    const {isNotesOpen} = this.state;
    return (
      <Grid item xs={3}>
        <Styles>
          <Card
            elevation={this.state.hover}
            className="card"
            onMouseOver={this.hoverActions}
            onFocus={this.hoverActions}
            onMouseOut={this.hoverOutActions}
            onBlur={this.hoverOutActions}
          >
            <CardContent className="media" image={null}>
              <div className={`card-overlay ${this.state.hover ? "up" : ""}`}>
                <Link to={`/portfolio/funds/${fund.id}`}>{fund.name}</Link> 
              </div>
              <div
                className={`actions ${this.state.hover ? "show" : "hidden"}`}
              >
                <div className="actions-container">
                  <Button
                    // component={Link}
                    // to={`/funds/${fund.id}`}
                    className="action-button"
                  >
                    <AddAlertIcon />
                  </Button>
                  <Button
                    // component={Link}
                    // to={`/funds/${fund.id}`}
                    className="action-button"
                  >
                    <AccessTimeIcon />
                  </Button>
                  <Button
                    onClick={() => {
                      this.openNotes();
                    }}
                    className="action-button"
                  >
                    <DescriptionIcon />
                  </Button>
                </div>
              </div>
            </CardContent>
            <CardContent className="card-content">
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell>LTV</TableCell>
                    <TableCell>{_.get(fund, 'fundMetricsV2.ltv', "\u2014")}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>DSCR</TableCell>
                    <TableCell>{_.get(fund, 'fundMetricsV2.dscrLender', "\u2014")}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Prepayment Penalty</TableCell>
                    <TableCell>{_.get(fund, 'fundMetricsV2.prepaymentPenalty', "\u2014")}</TableCell>
                  </TableRow>             
                </TableBody>
              </Table>
            </CardContent>
          </Card>
        </Styles>
        <FundNotes
          fundId={fund.id}
          isOpen={isNotesOpen}
          openNotes={this.openNotes}
          closeNotes={this.closeNotes}
        />
      </Grid>
    );
  }
};

export default Tile;
